import type { PressableProps, ViewStyle } from 'react-native'

import type { ICON } from '@/src/general/enums/icons'
import type { SlotsToClasses } from '@/src/types/slot-to-classes'

import type { TChipSlots, TChipVariantProps } from './chip-variants'

export type TChipProps = Pick<PressableProps, 'className' | 'testID'> & {
  text?: string
  style?: ViewStyle
  dataSet?: Record<string, string | boolean>
  size?: 'sm' | 'md'
  fontWeight?: 'normal' | 'bold'
  iconName?: ICON
  badgeInfo?: number | string
  onPress?: VoidFunction
  classNames?: SlotsToClasses<TChipSlots>
} & Omit<TChipVariantProps, 'hasIcon' | 'hasBadge' | 'hasText'>
